import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

export enum ActionTypes {
  FindNodes = '[STORE | CONTROL | SEARCH] Find Nodes',
  FindMedia = '[STORE | CONTROL | SEARCH] Find Media',
  FindDetachedPages = '[STORE | CONTROL | SEARCH] Find Detached Pages',
  FindSuccess = '[STORE | CONTROL | SEARCH] Find Success',
  FindMediaSuccess = '[STORE | CONTROL | SEARCH] Find Media Success',
  FindNodesSuccess = '[STORE | CONTROL | SEARCH] Find Nodes Success',
  FindDetachedPagesSuccess = '[STORE | CONTROL | SEARCH] Find Detached Pages Success',
  SetCurrentSelectedMediaResult = '[STORE | CONTROL | SEARCH] Set Current Selected Media Result',
  SetCurrentSelectedNodeResult = '[STORE | CONTROL | SEARCH] Set Current Selected Node Result',
  /**
   * Request
   */
  FindNodesRequest = '[REQUEST | CONTROL | SEARCH] Find Nodes',
  FindMediaRequest = '[REQUEST | CONTROL | SEARCH] Find Media',
  FindDetachedPagesRequest = '[REQUEST | CONTROL | SEARCH] Find Detached Pages',
}

// </editor-fold>

// <editor-fold desc="Store">

export class FindNodes {
  public static readonly type = ActionTypes.FindNodes;

  public constructor(public search: FlatModels.SearchControlModels.NodeSearch) {
  }
}

export class FindMedia {
  public static readonly type = ActionTypes.FindMedia;

  public constructor(public search: FlatModels.SearchControlModels.MediaSearch) {
  }
}

export class FindDetachedPages {
  public static readonly type = ActionTypes.FindDetachedPages;

  public constructor(public search: FlatModels.SearchControlModels.NodeSearch) {
  }
}

export class FindNodesSuccess {
  public static readonly type = ActionTypes.FindNodesSuccess;

  public constructor(public searchResults: FlatModels.SearchControlModels.NodeData[],
                     public totalPages?: number) {
  }
}

export class FindMediaSuccess {
  public static readonly type = ActionTypes.FindMediaSuccess;

  public constructor(public searchResults: FlatModels.SearchControlModels.MediaData[],
                     public totalMedia?: number) {
  }
}

export class FindDetachedPagesSuccess {
  public static readonly type = ActionTypes.FindDetachedPagesSuccess;

  public constructor(public searchResults: FlatModels.SearchControlModels.DetachedPageData[],
                     public totalPages?: number) {
  }
}

export class FindSuccess {
  public static readonly type = ActionTypes.FindSuccess;
}

export class SetCurrentSelectedMediaResult {
  public static readonly type = ActionTypes.SetCurrentSelectedMediaResult;
  
  public constructor(public currentSelectedMediaResult: FlatModels.SearchControlModels.MediaData | null) {
  }
}

export class SetCurrentSelectedNodeResult {
  public static readonly type = ActionTypes.SetCurrentSelectedNodeResult;
  
  public constructor(public currentSelectedNodeResult: string | null) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

export class FindNodesRequest {
  public static readonly type = ActionTypes.FindNodesRequest;

  public constructor(public search: FlatModels.SearchControlModels.NodeSearch) {
  }
}

export class FindMediaRequest {
  public static readonly type = ActionTypes.FindMediaRequest;

  public constructor(public search: FlatModels.SearchControlModels.MediaSearch) {
  }
}

export class FindDetachedPagesRequest {
  public static readonly type = ActionTypes.FindDetachedPagesRequest;

  public constructor(public search: FlatModels.SearchControlModels.NodeSearch) {
  }
}

// </editor-fold>
